import { SiteBrand } from "@/data/brand"
import { LetsGo } from "@/modules/helpers"
import "./index.scss"

LetsGo(SiteBrand)
